
export { GRANDIAZIENDE_CMS_DEFAULT } from "/home/jenkins/agent/workspace/web-sunrise-prod/web-sunrise-grandiaziende-deploy-prod/libs/grandiaziende/data-access/src/lib/cms/cms.config.ts"